import { brand } from "@/brandVariables/getBandVariables";
import { Box, Flex, Text } from "@radix-ui/themes";
import { FC } from "react";

import { formattedTime } from "../../../../helperFunctions/formatMsToTime";
import BaseUserAvatar from "../../../reusable/BaseUserAvatar";
import { ClientProps } from "../../../../hooks/useClientData";

export const LeaderboardHasThreeScores: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const winners = clientData.leaderboard.data?.slice(0, 3);
  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";
  return (
    <Box className="leaderboard__topThree">
      <Flex
        className="topThree"
        direction={"column"}
        gap={"4"}
        align={"end"}
        width={"90%"}
      >
        {winners?.map((winner) => {
          return (
            <Flex
              className="topThree__item"
              width={"100%"}
              gap={"3"}
              position={"relative"}
              align={"center"}
              p={"3"}
            >
              <Box>
                <BaseUserAvatar
                  userName={winner.profile.userName}
                  logoUrl={winner.profile.profileLogoUrl}
                />
              </Box>

              <Box className="topThree__info" ml={"4"}>
                <Text as="p" className="topThree__name" m={"0"} mb={"0.5rem"}>
                  {winner.profile.userName}
                </Text>

                <Flex gap={"8"} className="topThree__meta">
                  <Box>
                    <Text as="p" size={"5"}>
                      {brand.metaInfo.playerTeamOrCarKey}
                    </Text>
                    <Text size={"4"} className={isElgiganten}>
                      {brand.metaInfo.playerTeamOrCarValue}
                    </Text>
                  </Box>
                  <Box>
                    <Text as="p" size={"5"}>
                      Time:
                    </Text>
                    <Text size={"4"} className={isElgiganten}>
                      {formattedTime(winner.userChallengeData.points) || "-"}{" "}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};
